import { PropertyProfileWrapper, PropertyTypeImageWrapper, PropertyTypeLabelWrapper } from "./styles"; 

export const PropertyProfile = ({ lblhrc, lblNameClient}) =>(
    <PropertyProfileWrapper>
        
        <PropertyTypeImageWrapper>
            <img src={lblhrc} alt="imgPerfil"/> 
        </PropertyTypeImageWrapper>
        
        <PropertyTypeLabelWrapper>
            <h3>Bienvenido,</h3>
            <h2>
                <label>{lblNameClient || "Nombre de usuario de la finca"}</label>
            </h2>   
        </PropertyTypeLabelWrapper>
        
    </PropertyProfileWrapper>
    



)
    

    
    

    
